import React, { FC } from 'react'
import { UserClaims } from '@okta/okta-auth-js'
import { Link } from 'react-router-dom'
import {
  AppBar,
  Button,
  Toolbar,
  Box,
  IconButton,
  Icon,
} from '@mui/material'
import SearchBar from '../../apps/fleet-management/components/search-bar'
import AutonomyLogo from '../assets/autonomy-logo'
import GalpinLogo from '../assets/galpin-logo'
import Clients from './Clients'
import { useTheme } from '../../utils/themeContext'
import { getColorsForTheme } from '../../global-styles/clientColors'

export const TopNav: FC<{
  logout: () => void
  toggleSidebar: () => void
  isSidebarOpen: boolean
  user: UserClaims & { initials: string }
}> = ({ user, logout, toggleSidebar, isSidebarOpen }) => {
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  // Determine which logo to show based on current theme
  const LogoComponent = currentTheme === 'galpin' ? GalpinLogo : AutonomyLogo

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: (theme) => theme.palette.background.paper,
          height: '56px', // Reduced height
        }}
      >
        <Toolbar sx={{ minHeight: '56px !important', height: '56px' }}>
          <Box>
            <IconButton
              aria-label="toggle sidebar"
              onClick={toggleSidebar}
              sx={{
                marginRight: '10px',
                color: themeColors.buttonColor,
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.04)',
                }
              }}
            >
              <Icon>{isSidebarOpen ? 'menu_open' : 'menu'}</Icon>
            </IconButton>
            <Link to="/">
              <LogoComponent />
            </Link>
          </Box>
          <div style={{ flex: 0.5 }} />
          <SearchBar />
          <div style={{ flex: 0.5 }} />
          <Clients />
          <Button
            title="Log Out"
            variant="outlined"
            onClick={() => logout()}
            sx={{
              minWidth: '40px',
              width: '40px',
              height: '40px',
              borderRadius: '50%', // Make circular
              borderColor: themeColors.buttonColor,
              color: themeColors.buttonColor,
              fontSize: '14px',
              fontWeight: 'bold',
              '&:hover': {
                borderColor: themeColors.buttonHover,
                backgroundColor: 'rgba(0,0,0,0.04)',
                color: themeColors.buttonHover,
              }
            }}
          >
            {user.initials}
          </Button>
        </Toolbar>
      </AppBar>
    </>
  )
}
